import styled from 'styled-components';
import { RegionData } from '../quantData';
import { useModal } from '../../../context/ModalContext';
import { useQuantContext } from '../../../context/QuantContext';

interface Props {
  userRegions: string[];
  userGrade: string | null;
}

function RegionSelect({ userRegions, userGrade }: Props) {
  const { modalDispatch } = useModal();
  const { selectedRegions, setSelectedRegions } = useQuantContext();
  const handleClickRegion = (region: string) => {
    if (!userGrade) {
      modalDispatch({ type: 'USER_ALERT', payload: 'free' });
      return;
    }
    if (!userRegions.includes(region)) {
      modalDispatch({ type: 'USER_ALERT', payload: 'local' });
      return;
    }

    if (region === '전국') {
      setSelectedRegions([]);
    } else {
      if (selectedRegions.includes(region)) {
        setSelectedRegions(selectedRegions.filter((r) => r !== region));
      } else {
        setSelectedRegions([...selectedRegions, region]);
      }
    }
  };

  const checkSelected = (region: string) => {
    if (region === '전국') {
      if (selectedRegions.length > 0) return false;
      return true;
    } else {
      return selectedRegions.includes(region);
    }
  };

  const sortedRegionData = [
    ...RegionData.filter((r) => userRegions.includes(r)),
    ...RegionData.filter((r) => !userRegions.includes(r)),
  ];

  return (
    <Container>
      <Title>지역 선택</Title>
      <OptionWrapper>
        {sortedRegionData.map((item) => (
          <OptionItem
            key={item}
            $isSelected={checkSelected(item)}
            onClick={() => handleClickRegion(item)}
            $disabled={!userRegions.includes(item)}
          >
            {item}
          </OptionItem>
        ))}
      </OptionWrapper>
    </Container>
  );
}

export default RegionSelect;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  width: 100%;
`;

const OptionItem = styled.button<{ $isSelected?: boolean; $disabled: boolean }>`
  display: flex;
  min-width: 76px;
  height: 48px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: ${({ $isSelected }) =>
    $isSelected ? '2px solid #008AFF' : '1px solid #E5E8EA'};
  background: #f7f8fc;
  cursor: pointer;
  outline: none;

  color: ${({ $isSelected }) => ($isSelected ? '#008AFF' : '#616161')};
  text-align: center;

  font-size: 14px;
  font-weight: ${({ $isSelected }) => ($isSelected ? '700' : '500')};
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;

  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
`;
